<script>

/**
 * Automodal 
 * 
 * Version 1.1
 * Se pasa a ui-edit-auto-modal el parámetro :form-id, requerido para el controld de borrado.
 * 
 * Version 1.0
 * Placeholder base
 */

import _ from 'lodash'

import {archetype, automodalHandler} from './archetype'

export default {
    name: 'franquiciasAutomodal',
    props: {
        conceptId: {
            type: [String, Number],
        },
        archetype: {
            type: [Array, Object],
            default: () => archetype
        }
    },
    data: () => {
        return {
            form: {
                id: null
            },
            asides: {
            }
        }
    },
    computed: {
        cArchetype(){
            let updated = [];
            _.forEach(archetype, itemsRow => {
                if(!_.isArray(itemsRow)){
                    updated.push(itemsRow);
                    return
                } 
                let adding = []
                _.forEach(itemsRow, item => {
                    // EVALUACIÓN DINÁMICA POR ELEMENTO DE ARQUETIPO

                    // if(item.key == 'key-name'){
                        // DO SOMENTHING
                    // }

                    adding.push(item)
                })
                updated.push(adding)
            })
            return updated
        }
    },
    methods: {
        getHandler(){
            return automodalHandler(this.conceptId)
        },
        refresh(){
            this.$emit('refresh');
        },
        checkAsides(){
            const asides = this.$refs.automodal.getAsides();
            if(!!asides){
                // this.asides.parent                      = asides.parent
            }
        },
        onDisplay(){
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL HA CARGADO DOM COMPLETAMENTE.
        },
        onHidden(){
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL SE HA OCULTADO
        },

    },
    watch: {
        'form.id'(){
            
        }
    }
}
</script>

<template>
    <div>
        <ui-edit-auto-modal v-model="form" 
        	:form-id="form.id" 
        	ref="automodal" 
        	:form-archetype="cArchetype" 
        	@refresh="refresh()" 
        	:handler="getHandler()" 
        	size="sm" 
        	@defined="checkAsides()" 
        	@display="onDisplay" 
    		@hidden="onHidden" 
        	:allow-aside="false" 
        	:allow-delete="true">
            <slot name="default"><i class="fa fa-cog"></i></slot>
            <b-col slot="aside" cols="7">
                <!-- LATERAL, REQUIERE :allow-aside="true" -->
            </b-col>
            <b-col slot="bottom" v-if="false">
                <!-- AGREGAR AL FONDO... -->
            </b-col>
        </ui-edit-auto-modal>
    </div>
</template>